import type { Product } from '../../model/index.ts'

export const mrpProducts = ['mrph', 'mrpw', 'mrpa', 'es-mrpw', 'fr-mrpaxe'] as const satisfies Product[]
export type MrpProduct = (typeof mrpProducts)[number]

export function isMrpProduct(product: string): product is MrpProduct {
  return mrpProducts.includes(product as MrpProduct)
}

export const mrpOccupationStatusLabels = {
  proprietaireOccupant: 'Propriétaire occupant intégralement les bâtiments assurés',
  coProprietaireOccupant: 'Copropriétaire occupant intégralement les bâtiments assurés',
  locatairePourLeCompteDuProprietaire: 'Locataire souscrivant une assurance dommages pour le compte du propriétaire',
  locataire: 'Locataire ou occupant à tout autre titre',
} as const
